package com.eladfinish.bible.contest.screens.completeVerse.ui.dialogs.numberPicker

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.eladfinish.bible.contest.ui.common.PreviewTheme

@Composable
fun NumberPickerContainer(
    valuesPickerState: PickerState,
    value: Int,
) {
    val values = remember { (0..10).map { it.toString() } }

    Column(
        modifier = Modifier
            .fillMaxWidth(),
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        Picker(
            state = valuesPickerState,
            items = values,
            startIndex = value,
            visibleItemsCount = 3,
            modifier = Modifier.fillMaxWidth(0.5f),
            textModifier = Modifier.padding(8.dp),
            textStyle = MaterialTheme.typography.bodyLarge.copy(
                fontSize = 22.sp
            ),
            dividerColor = Color.Gray.copy(alpha = 0.5f),
        )
    }
}

@Preview(showBackground = true, heightDp = 150)
@Composable
private fun NumberPickerContainerPreview() {
    val pickerState = remember {
        PickerState().apply {
            selectedItem = "5"
        }
    }

    PreviewTheme {
        NumberPickerContainer(
            valuesPickerState = pickerState,
            value = 5,
        )
    }
}
